export enum ProfileReactionProperties {
  Media = 'media',
  Reaction = 'reaction',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  ProfileId = 'profileId',
}
export enum ProfileReactionMetaProperties {
  MediaId = 'Media-id',
  MediaVersion = 'Media-version',
}
